var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"pipefishGreen","small":"","to":"/admin"}},[_c('v-icon',{staticClass:"backIcon",attrs:{"left":"","dark":""}},[_vm._v("mdi-arrow-left")]),_vm._v("\n  Back\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }